import axios from "axios";

export const state = {
    pocketmoney: [],
};

export const getters = {
    pocketmoney: state => state.pocketmoney,
};

export const mutations = {
    setMoney(state, newValue) {
        state.pocketmoney = newValue
    },
};

export const actions = {
    fetchMoney({ commit }) {
        axios.get('/pocketmoney').then(res => {
            commit('setMoney', res.data.pocketmoney);
        })
    },
    filterPM({commit}, {schoolterm,year}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        let url = "/filterpocketmoney";
        axios.post(url, formData).then((response) => {
            commit('setMoney', response.data.pocketmoney)
        })
    },
   
};
